import { ArrowLeftOutlined } from '@ant-design/icons';
import * as React from 'react';
import { useNavigate } from 'react-router';

import {
  ActionKind,
  ActionParamsButton,
  BaseClickable,
  SpacingRow,
  SpacingRowAlign,
  SpacingRowItem,
  SpacingUnit,
} from 'components/ui';
import { PropsWithClassName } from 'types/common';

import { BaseLayout, Logout } from '../components';

import s from './CreateFormLayout.module.scss';

type Props = React.PropsWithChildren<PropsWithClassName> & {
  buttonNodes?: React.ReactNode;
  titleNode?: React.ReactNode;
  /** При string идёт переход на определённый роут, при number переходим на N роутов назад*/
  pathBack?: string | number;
};

const CreateFormLayout: React.FC<Props> = ({
  className,
  children,
  buttonNodes,
  titleNode,
  pathBack = -1,
}) => {
  const navigate = useNavigate();

  const action = React.useMemo(
    (): ActionParamsButton<any> => ({
      actionKind: ActionKind.button,
      complexOnClick: {
        onClick: () => {
          if (typeof pathBack === 'number') {
            navigate(pathBack);

            return;
          }

          navigate(pathBack, { replace: true });
        },
      },
    }),
    [navigate, pathBack]
  );

  return (
    <BaseLayout
      className={className}
      header={
        <div className={s.layout__header}>
          <SpacingRow
            className={s.layout__headerLeft}
            align={SpacingRowAlign.center}
            hSpacing={SpacingUnit.unit3}
            vSpacing={SpacingUnit.none}
          >
            <BaseClickable withHover action={action}>
              <ArrowLeftOutlined className={s.layout__headerLeftIcon} />
            </BaseClickable>
            <SpacingRowItem grow>{titleNode}</SpacingRowItem>
          </SpacingRow>
          <SpacingRow
            hSpacing={SpacingUnit.unit2}
            align={SpacingRowAlign.center}
          >
            {buttonNodes}
          </SpacingRow>
          <Logout />
        </div>
      }
    >
      <div className={s.layout__content}>{children}</div>
    </BaseLayout>
  );
};

export default CreateFormLayout;
